import {
    SkyNetTableField,
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import injectFieldsToTabs from 'app/shared-components/SkyNetTable/hooks/utils/injectFieldsToTabs'
import {
    FilterType, CommonRoutes,
} from 'app/enums/common.enums'

import {
    AddressCategory,
    LocationType,
} from 'app/enums/label.enums'

export const getTabUrl = (name: LocationType) => {
    const tabUrls = {
        [LocationType.ADDRESS]: 'address',
        [LocationType.AIRPORT]: 'airport',
        [LocationType.SEAPORT]: 'seaport',
    }

    return tabUrls[name] || CommonRoutes.All
}

const fields: SkyNetTableField[] = [
    {
        name: 'locationName',
        reduced: true,
        labelKey: 'LOCATION',
    },
    {
        name: 'addressLine1',
        filterType: FilterType.Array,
        labelKey: 'ADDRESS_LINE_1',
    },
    {
        name: 'zip',
        filterType: FilterType.Array,
        labelKey: 'ZIP_CODE',
    },
    {
        name: 'city',
        reduced: true,
        labelKey: 'CITY',
    },
    {
        name: 'countryName',
        filterField: 'countryName',
        filterType: FilterType.Array,
        reduced: true,
        labelKey: 'COUNTRY',
    },
    {
        name: 'isMainAddress',
        componentName: 'ChipCheckMark',
        labelKey: 'IS_MAIN_ADDRESS',
    },
    {
        name: 'companyName',
        filterField: 'companyName',
        filterType: FilterType.Array,
        labelKey: 'COMPANY',
    },
    {
        name: 'addressCategory',
        componentName: 'EnumList',
        allowedValuesEnum: AddressCategory,
        labelKey: 'CATEGORY',
    },
]

const config: SkyNetTableConfig = {
    name: 'LocationTable',
    tabs: injectFieldsToTabs([
        {
            name: 'All Locations',
            url: CommonRoutes.All,
        },
        {
            name: 'Addresses',
            url: getTabUrl(LocationType.ADDRESS),
            includeFilters: {
                locationType: [LocationType.ADDRESS],
            },
        },
    ], fields),
}

export default config
